import Model, { attr } from '@ember-data/model';

import { UserAccess } from 'webapp/enums/enums';

export default class BoardLoopRecord extends Model {
	@attr('string') declare title: string;
	@attr('number') declare ownerId: number | null;
	@attr('number') order!: number; // order is used for sorting of templates
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	users!: number[];
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	declare boardIds: number[];
	@attr('string') declare token: string;
	@attr('boolean', { defaultValue: false }) declare isPublicEnabled: boolean;
	@attr('number') declare created: number;
	@attr('number') declare createdBy: number;
	@attr('number') originateFrom!: number | null;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	declare tags: number[];
	@attr('number') declare loopDelay: number;
	@attr('number', { defaultValue: UserAccess.PUBLIC }) access!: number;
	@attr('number') templateId!: number | null;
	@attr('number') spaceId!: number;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	declare restrictIps: string[];
	@attr('string') declare password: string;
	@attr('boolean', { defaultValue: true }) declare allowAnonymousDateRangeEdit: boolean;
	@attr('boolean', { defaultValue: true }) declare allowAnonymousFilterEdit: boolean;
	@attr('boolean') favorite!: boolean;
	@attr('number') deleted!: number | null;

	// only for internal webapp use
	@attr('boolean') newBadge!: boolean;
}
